import React, { PropTypes } from 'react'
import cn from 'classnames'

const WizardItem = ({ step, title, active, onClick }) => {
  return (
    <li className={cn({active: active})}>
      <button type="button" onClick={onClick.bind(this, step)}>{title}</button>
    </li>
  )
}

WizardItem.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
}

export default WizardItem



// WEBPACK FOOTER //
// ./src/components/Wizard/wizard-item.js